import React, {useCallback, useEffect, useRef, useState} from "react"
import DataGrid, {
    Column, MasterDetail, Pager, Paging, SearchPanel, Selection, Sorting, Toolbar
} from 'devextreme-react/data-grid'
import {useAuth} from "../../contexts/auth"
import LoadPanel from 'devextreme-react/load-panel'
import Button from 'devextreme-react/button'
import notify from "devextreme/ui/notify"
import AccessDenied from "../../components/access-denied/access-denied"
import {verifyAccess} from '../../utils/admin.utils.js'
import {faFileLines, faKey} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {clientSignRefused, getDogovorRequests, getRequestAttach} from "../../api/newdog"
import {Buffer} from "buffer"
import {Item} from "devextreme-react/toolbar"
import './tech-connection.scss'
import {getddMMyyyy} from "../../utils/date.utils"
import PopSelectCert from "../../components/cryptopro/PopSelectCert"
import {Popup} from "devextreme-react/popup"
import ScrollView from "devextreme-react/scroll-view"
import {TextBox} from "devextreme-react"
import {Validator as ValidatorDevex, RequiredRule as RequiredRuleValidator} from "devextreme-react/validator"
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon"

const TECH_CONNECTION_DOC_TYPES = [
    {fileType: [879, 902], label: 'Проект договора энергоснабжения/Соглашение'},
    {fileType: [878, 901], label: 'Акт технологического присоединения'},
    {fileType: [877, 900], label: 'Акт допуска в эксплуатацию прибора учета электроэнергии'},
    {fileType: [880, 903], label: 'Соглашение о внесении изменений'},
]

const findAttachmentForType = (attachments, fileType) => {
    if (!attachments || !fileType?.length) return null
    const forType = attachments.filter(a => fileType.includes(+a.file_type))
    return forType.find(a => a.company_key_name) || forType[0] || null
}

const TechConnectionPage = () => {

    const [visiblePage, setVisiblePage] = useState(true)
    const {selectedDog} = useAuth()
    const [loading, setLoading] = useState(false)
    const [techConnections, setTechConnections] = useState(null)
    const dataGridRef = useRef(null)
    const isFirstLoad = useRef(true)
    const [expandedRowKeys, setExpandedRowKeys] = useState([])
    const [popupRefusedVisible, setPopupRefusedVisible] = useState(false)
    const [refusedMessage, setRefusedMessage] = useState('')
    const [refusalContext, setRefusalContext] = useState({idReq: null, idFile: null})

    // права на страницу
    useEffect(() => {
        const pageRoles = [1]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
            return null
        } else setVisiblePage(true)
    }, [selectedDog])

    const getTechConnections = useCallback(async () => {
        setLoading(true)
        const res = await getDogovorRequests(selectedDog.kodDog)
        if (res.isOk) {
            setTechConnections(res.data)
            isFirstLoad.current = true
        } else {
            notify(res.message, 'error', 10000)
        }
        setLoading(false)
    }, [selectedDog])

    // грузим заявки/объекты
    useEffect(() => {
        (async function () {
            await getTechConnections()
        })()
    }, [getTechConnections])

    // открываем первую строку автоматически
    useEffect(() => {
        if (isFirstLoad.current && techConnections && techConnections.requests?.length > 0) {
            setTimeout(() => {
                const firstKey = techConnections.requests[0].id
                dataGridRef.current.instance.expandRow(firstKey)
                setExpandedRowKeys([firstKey])
                isFirstLoad.current = false
            }, 0)
        }
    }, [techConnections])

    const downloadAttachmentById = async (idAttach) => {
        if (!idAttach) return
        setLoading(true)
        try {
            const res = await getRequestAttach(idAttach)
            if (res.isOk) {
                const data = res.data.attachment?.data
                if (!data) {
                    notify('Файл не найден', 'error', 5000)
                    return
                }
                const filename = res.data.filename
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(data), filename)
            } else {
                notify(res.message, 'error', 5000)
            }
        } catch (e) {
            notify('Файл отсутствует', 'error', 5000)
        } finally {
            setLoading(false)
        }
    }

    const onSuccessSign = async () => {
        notify('Документ успешно подписан!', 'success', 5000)
        await getTechConnections()
    }

    const hidePopRefused = () => {
        setRefusedMessage('')
        setPopupRefusedVisible(false)
    }

    const onFormSubmitRefused = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            const res = await clientSignRefused(refusalContext.idReq, refusalContext.idFile, refusedMessage)
            if (res.isOk) {
                await getTechConnections()
                setRefusedMessage('')
                notify(res.message, 'success', 5000)
            } else {
                notify(res.message, 'error', 5000)
            }
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setLoading(false)
            hidePopRefused()
        }
    }

    const onRowClick = async (e) => {
        if (e.rowType !== 'data') return
        let key = e.component.getKeyByRowIndex(e.rowIndex)
        let expanded = e.component.isRowExpanded(key)
        if (expanded) {
            e.component.collapseRow(key)
            setExpandedRowKeys([])
        } else {
            e.component.collapseAll(-1)
            e.component.expandRow(key)
            setExpandedRowKeys([key])
        }
    }

    const DiffCell = (cellData) => {
        const data = cellData.data
        const isExpanded = expandedRowKeys.includes(data.id)
        return (
            <div className={'cursorPointer'}>
                <div className="cell-content">
                    <span className='spanItem' style={{fontWeight: 'bold'}}>{data.obj_label} {data.adress}</span><br/>
                    <small>Заявка на технологическое присоединение <strong>№{data.num_tehp_req}</strong> от {getddMMyyyy(data.date_create)} - <span className={'status-' + data.id_status.toString()}>{data.status}</span></small>
                </div>
                <span className={`chevron ${isExpanded ? 'expanded' : 'collapsed'}`}></span>
            </div>
        )
    }

    return (
        <>{visiblePage ?
            <div className={'content-block dx-card responsive-paddings tech-connection'}>
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines}/>
                <h3><strong>Технологическое присоединение</strong></h3>
                {techConnections?.requests?.length > 0 ?
                    <>
                        <p>Порядок заключения договора энергоснабжения до завершения процедуры технологического присоединения описан в разделе <a target={'_blank'} rel={'noopener noreferrer'} href="https://r-energiya.ru/business-clients/elektrosnabzhenie/contracts.html">Как заключить/Изменить договор</a></p>
                        { techConnections.tunable_text  ? <p dangerouslySetInnerHTML={{__html: techConnections.tunable_text }}/> : null }
                        <LoadPanel visible={loading}/>
                        <>
                            <DataGrid
                                ref={dataGridRef}
                                className="lettersGrid"
                                dataSource={techConnections.requests}
                                keyExpr="id"
                                allowColumnReordering={true}
                                width="100%"
                                showBorders={false}
                                onRowClick={onRowClick}
                                showColumnHeaders={false}
                                wordWrapEnabled={true}
                            >
                                <Toolbar>
                                    <Item name="searchPanel"/>
                                </Toolbar>
                                <SearchPanel visible={true}/>
                                <Paging defaultPageSize={10}/>
                                <Pager
                                    visible={true}
                                    allowedPageSizes={[5, 10, 20, 50, 'all']}
                                    displayMode={'full'}
                                    showPageSizeSelector={true}
                                    showInfo={true}
                                    showNavigationButtons={true}/>
                                <Selection mode="single"/>
                                <Column dataField="createdAt" dataType="string" cellRender={DiffCell}/>
                                <MasterDetail enabled={false} render={CustomItemGrid}/>
                                <Column dataField="inn" dataType="string" visible={false}/>
                                <Column dataField="kpp" dataType="string" visible={false}/>
                                <Column dataField="contact" dataType="string" visible={false}/>
                                <Column dataField="fio" dataType="string" visible={false}/>
                                <Column dataField="kod_numobj" dataType="string" visible={false}/>
                                <Column dataField="num_tehp_req" dataType="string" visible={false}/>
                                <Column dataField="obj_label" dataType="string" visible={false}/>
                                <Column dataField="adress" dataType="string" visible={false}/>
                                <Column dataField="date_create" dataType="string" visible={false}/>
                                <Column dataField="status" dataType="string" visible={false}/>
                                <Column dataField="name_company" dataType="string" visible={false}/>
                            </DataGrid>
                        </>
                    </>
                    :
                    <>
                        <p>
                            В настоящее время в работе нет заявок на технологическое присоединение к электрическим сетям энергопринимающих устройств, максимальная мощность которых не превышает <strong>150 кВт</strong>, а категория надежности – <strong>не выше второй</strong>.
                        </p>
                        <p>
                            Подать заявку на технологическое присоединение к электрическим сетям энергопринимающих устройств в сетевую организацию можно любым способом, в том числе в личном кабинете на сайте Сетевой организации. <a target={'_blank'} rel={'noopener noreferrer'} href="https://r-energiya.ru/business-clients/elektrosnabzhenie/contracts.html">Подробнее</a>.
                        </p>
                    </>
                }
                <Popup
                    visible={popupRefusedVisible}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    title="Отказ от подписи"
                    maxWidth={600}
                    maxHeight={'90%'}
                    height={'auto'}
                    onHiding={hidePopRefused}
                    titleRender={() => PopupTitleWithIcon(faKey, "Отказ от подписи", hidePopRefused)}
                >
                    <ScrollView width='100%' height='100%'>
                        <form onSubmit={onFormSubmitRefused} tabIndex={0} onKeyDown={(e) => {
                            if (e.key === 'Escape') hidePopRefused()
                        }}>
                            <TextBox
                                showClearButton={true}
                                value={refusedMessage}
                                labelMode='floating'
                                label={'Причина отказа'}
                                onValueChanged={(e) => setRefusedMessage(e.value)}>
                                <ValidatorDevex>
                                    {popupRefusedVisible && <RequiredRuleValidator message={'Обязательное поле'}/>}
                                </ValidatorDevex>
                            </TextBox>
                            <Button useSubmitBehavior={true} className={'float-right mt-4'} text='Отправить'/>
                        </form>
                    </ScrollView>
                </Popup>
            </div>
            : <AccessDenied/>}</>
    )

    function CustomItemGrid(props) {
        const data = props.data

        const rows = TECH_CONNECTION_DOC_TYPES.map((docType, idx) => {
            const attachment = findAttachmentForType(data.attachments, docType.fileType)
            
            return {
                idx,
                label: attachment?.name_type || docType.label,
                fileType: docType.fileType,
                attachmentId: attachment?.id || null,
                companyKeyName: attachment?.company_key_name || null,
                clientKeyName: attachment?.client_key_name || null,
                clientSignRefused: attachment?.client_sign_refused || false,
                d_c: attachment?.d_c || null,
            }
        })

        const labelRender = (cellData) => {
            const hasFile = !!cellData.data.attachmentId
            return <span style={{color: hasFile ? 'inherit' : '#999'}}>{cellData.data.label}</span>
        }

        const signRender = (cellData) => {
            const row = cellData.data
            
            if (!row.attachmentId || !row.companyKeyName) return null
            if (row.clientSignRefused) {
                return (
                    <span title='Отказались от подписи' className='p-2 danger'>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.58681 16.5962L1.96378 18L10.982 8.80608C11.6929 9.23774 12.505 9.47589 13.3573 9.47589C14.5983 9.47589 15.7662 8.9847 16.6422 8.08698C18.4526 6.24129 18.4526 3.2346 16.6422 1.38891C15.7662 0.495838 14.5982 2.01491e-06 13.3573 1.90642e-06C12.1164 1.79794e-06 10.9484 0.491193 10.0724 1.38891C8.45629 3.03646 8.28658 5.61137 9.55679 7.45706L6.07728 11.0044L4.56891 9.4666L3.19194 10.8704L4.70031 12.4082L2.88534 14.2585L1.37697 12.7207L-9.26741e-07 14.1245L1.50837 15.6623L0.588561 16.6L0.58681 16.5962ZM11.4447 2.79259C11.9557 2.27163 12.6318 1.98882 13.3527 1.98882C14.0727 1.98882 14.7543 2.27627 15.2608 2.79259C16.312 3.86428 16.312 5.61042 15.2608 6.68759C14.7498 7.20855 14.0736 7.49136 13.3527 7.49136C12.6328 7.49136 11.9511 7.20391 11.4446 6.68759C10.3934 5.6159 10.3934 3.86976 11.4447 2.79259Z"/>
                        </svg>
                    </span>
                )
            }
            return (
                <div className='d-flex flex-row align-items-center'>
                    <div className='mr-1'>
                        <PopSelectCert
                            companyKeyName={row.companyKeyName}
                            idFile={row.attachmentId}
                            clientKey={!!row.clientKeyName}
                            onSuccessSign={onSuccessSign}
                        />
                    </div>
                    {!row.clientKeyName && (
                        <Button
                            type='danger'
                            hint='Отказаться от подписи документа'
                            icon={'images/flash.svg'}
                            onClick={() => {
                                setRefusalContext({idReq: data.id, idFile: row.attachmentId})
                                setRefusedMessage('')
                                setPopupRefusedVisible(true)
                            }}
                        />
                    )}
                </div>
            )
        }

        const fileRender = (cellData) => {
            const row = cellData.data
            return (
                <Button
                    text='Скачать'
                    type='default'
                    disabled={!row.attachmentId}
                    onClick={() => downloadAttachmentById(row.attachmentId)}
                />
            )
        }

        return (
            <>
                <p>{data.name_company}</p>
                <DataGrid
                    keyExpr="idx"
                    dataSource={rows}
                    showBorders={true}
                    columnAutoWidth={true}
                    wordWrapEnabled={true}
                    className='mb-4'
                    allowColumnResizing={true}
                    rowAlternationEnabled={true}
                    noDataText="Нет документов"
                >
                    <Sorting mode="none"/>
                    <Column dataField="d_c" caption="Дата" format="dd.MM.yyyy" dataType="datetime" allowEditing={false} width={110}/>
                    <Column caption="Тип документа" cellRender={labelRender} allowEditing={false}/>
                    <Column caption="Подписание" cellRender={signRender} allowEditing={false} width={130}/>
                    <Column caption="Файл" cellRender={fileRender} allowEditing={false} width={110}/>
                </DataGrid>
                <p>Вы можете подписать договор (соглашение) прямо на сайте или скачать его, добавить электронно-цифровую подпись и направить нам посредством электронного документооборота СБИС, Диадок.</p>
                <p>Также подписанный договор (соглашение) можно вернуть по адресу: г. Рязань, ул. Радищева, д. 61, каб. 1.</p>
                <p>Договор (соглашение) считается заключённым с даты составления акта об осуществлении технологического присоединения
                    (уведомление об обеспечении сетевой организацией возможности присоединения к электрическим сетям) <a target={'_blank'} rel={'noopener noreferrer'} href="https://r-energiya.ru/business-clients/elektrosnabzhenie/contracts.html">Подробнее</a></p>
            </>
        )
    }
}

export default TechConnectionPage
